<template>
  <bs-box-panel>
    <div slot="title">
      <div class="bs-title">
        <span>本年农事作业</span>
        <count-to
          class="count-class"
          :start-val="startVal"
          :end-val="totalCount"
          :multiLen="200"
          :duration="duration"
        />
        <span class="unit">条</span>
      </div>
    </div>
    <div id="rightBtmModule">
      <!-- 滚动区域 -->
      <div
        class="Bscroll-container"
        ref="BScrollWrap"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <div class="Bscroll-wrap" ref="movebox" v-show="dataList.length">
          <div
            class="Bscroll-slide"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div class="line-wrap"></div>
            <div class="slide-main-wrap">
              <div class="slide-main">
                <p class="panel-head">
                  <span class="t-t">{{ item.farmName }} </span>
                  <span class="">
                    {{ getTsFormatDate(item.operationTime) }}
                  </span>
                </p>
                <p class="panel-des">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>

        <empty v-if="!loading && !dataList.length"></empty>
      </div>
    </div>
  </bs-box-panel>
</template>

<script>
import { farmRealTimeDynamic } from "@/api/request/snkd.produce";
import { mapState } from "vuex";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import BsBoxPanel from "@/components/bs/BsBoxPanel";
import CountTo from "@/components/bs/BsBoxPanel/CountTo";

export default {
  name: "AgriculturalWork",
  data() {
    return {
      totalCount: 0,
      startVal: 0,
      endVal: 0,
      duration: 3000,
      loading: false,
      dataList: [],
      pageSize: 50,
      routerName: "", // 保存当前路由name
      stop: false,
      scrollTimer: null, // 滚动定时器
      stepNumber: 1, // 1px 一动
      stepTime: 40, // 隔多少ms 一动
      initIndex: 0, // 初始化序号 标记resize 定时器序号 防止网速不稳定时，上一个定时器没清除问题
    };
  },

  components: { Empty, BsBoxPanel, CountTo },
  created() {
    this.initModule();
  },
  methods: {
    // todo: initMoudle
    async initModule() {
      // 保存当前路由name
      this.routerName = this.$route.name;

      // 初始化 滚动条
      this.loading = true;
      this.stop = false;
      this.dataList = [];
      const initIndex = ++this.initIndex;
      this.scrollTimer && clearInterval(this.scrollTimer);
      await this._updateData(); // 拉第一页数据
      this.loading = false;

      if (!this.dataList.length || this.dataList.length < this.pageSize) return;
      if (initIndex !== this.initIndex) return;
      this.initReadyBScroll(this.BScrollWrap);

      // 鼠标移入移出停止控制
      this.BScrollWrap.removeEventListener("mouseover", this._mouseoverEvent);
      this.BScrollWrap.removeEventListener("mouseout", this._mouseoutEvent);

      this.BScrollWrap.addEventListener("mouseover", this._mouseoverEvent);
      this.BScrollWrap.addEventListener("mouseout", this._mouseoutEvent);
    },
    async initReadyBScroll(BScrollWrap, pageSize = this.pageSize) {
      this.scrollTimer && clearInterval(this.scrollTimer);
      // 删掉上一页
      if (this.dataList.length === pageSize * 2) {
        this.dataList.splice(0, pageSize);
      }
      await this.nextTick();

      //* 容器,位置清零
      BScrollWrap.scrollTop = 0;
      //* 内容可滚动高度 或者 内容高度为0
      if (
        BScrollWrap.scrollHeight - BScrollWrap.clientHeight === 0 ||
        BScrollWrap.scrollHeight === 0
      )
        return;
      // 拉取下一页数据
      this._updateData();

      // 开启定时器滚动
      var scrollResult = await this.initBScroll(BScrollWrap);
      if (!scrollResult) return;
      this.initReadyBScroll(BScrollWrap, pageSize);
    },
    initBScroll(BScrollWrap) {
      return new Promise((resolve) => {
        let scrollTop = BScrollWrap.scrollTop;
        let scrollHeight = BScrollWrap.scrollHeight;

        // 鼠标经过时设置i=0达到鼠标经过停止效果
        this.scrollTimer = setInterval(() => {
          if (this.stop) return;

          if (scrollTop >= scrollHeight) {
            clearInterval(this.scrollTimer);
            resolve(true);
          } else {
            scrollTop += this.stepNumber;
            BScrollWrap.scrollTop = scrollTop;
          }
        }, this.stepTime);
      });
    },
    refreshRender() {
      // 更新渲染
      setTimeout(() => {
        this.initMoudle();
      }, 100);
    },
    stopRender() {
      // 跳转页面是 停止渲染
      this.BScrollWrap.removeEventListener("mouseover", this._mouseoverEvent);
      this.BScrollWrap.removeEventListener("mouseout", this._mouseoutEvent);
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
      this.dataList = [];
      this.stop = true;
    },

    // todo: service controller
    async getFarmRealTimeDynamicController() {
      try {
        let res = await this.getFarmRealTimeDynamicService();
        const { list } = res;
        //* 截取最新size条数据
        const newlist = this.setPageSizeDataSlice(list, this.pageSize);
        this.dataList.push(...newlist);
      } catch (e) {
        this.dataList = [];
        console.log(e);
      }
    },

    // todo: service
    async getFarmRealTimeDynamicService() {
      try {
        const res = await farmRealTimeDynamic.listByFarmIdsService({
          farmId: this.farmId,
          pageNo: 1,
          pageSize: 50,
        });
        this.totalCount = res.totalCount;
        return res;
      } catch (e) {
        console.log(e);
      }
    },

    getTsFormatDate(n) {
      n = new Date(n);
      return (
        n.toLocaleDateString().replace(/\//g, "-") +
        " " +
        n.toTimeString().substr(0, 5)
      );
    },

    // todo: utils
    //* 更新数据
    async _updateData() {
      if (this.routerName !== this.$route.name) return this.stopRender(); // 退出当前页面了 不加载了
      await this.getFarmRealTimeDynamicController();
      // 第size条数据添加样式
      this.setLastPageSizeStyle({ elParentClass: "Bscroll-slide" });
    },
    _mouseoverEvent() {
      this.stop = true;
    },
    _mouseoutEvent() {
      this.stop = false;
    },
    //* 第size条数据添加样式
    setLastPageSizeStyle({ elParentClass, pageSize = this.pageSize } = {}) {
      const elParent = document.querySelector(
        `.${elParentClass}:nth-of-type(${pageSize}n)`
      );
      if (elParent) elParent.classList.add("lastLine");
    },
    //* 获取当前页滚动高度
    getPageScrollTop(dom, pageSize) {
      // 获取当前页滚动高度
      var containerH = Math.floor(dom.outerHeight()); // 容器高度
      var pageLastLi = dom.find("li").eq(pageSize - 1);
      var onepageoverTop = Math.floor(
        pageLastLi.get(0).offsetTop -
          dom.get(0).offsetTop +
          pageLastLi.height() +
          pageLastLi.width() * 0.38
      ); // 获取一页滚动长度
      return [onepageoverTop, onepageoverTop - containerH];
    },
    //* 截取最新size条数据
    setPageSizeDataSlice(list, size) {
      var data = JSON.parse(JSON.stringify(list));
      if (!data.length) return [];
      if (data.length >= size) {
        return data.splice(0, size);
      }
      var lack = size - data.length;
      if (lack >= data.length) {
        while (data.length < size) {
          data.push(...JSON.parse(JSON.stringify(data)));
        }
        return data.splice(0, size);
      } else {
        var clone = JSON.parse(JSON.stringify(list));
        data.push(...clone.splice(0, lack));
        return data;
      }
    },
    nextTick() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          resolve(true);
        });
      });
    },
  },
  computed: {
    BScrollWrap() {
      return this.$refs.BScrollWrap;
    },

    ...mapState(["companyId", "farmId"]),
  },
  beforeDestroy() {
    // 切换动态组件时停止渲染
    this.stopRender();
  },
  destroyed() {
    // 停止渲染
    this.stopRender();
  },
  deactivated() {
    // 切换动态组件时停止渲染
    this.stopRender();
  },
};
</script>

<style scoped lang="scss">
.bs-title {
  display: flex;
  align-items: center;
  position: relative;
  left: 20px;
  height: 40px;
  color: #32c375;
  font-size: 20px;
  font-weight: bold;
  .count-class {
    padding: 0 5px;
  }
  .unit {
    //padding-left: 20px;
    font-size: 14px;
  }
}
#rightBtmModule {
  margin-top: 10px;
  width: 100%;
  height: 100%;
  .Bscroll-container {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    overflow: hidden;
    .Bscroll-wrap {
      width: 100%;
      display: inline-block;
      .Bscroll-slide {
        position: relative;
        .line-wrap {
          width: 20px;
          height: 100%;
          position: absolute;
          display: inline-block;
          &:before,
          &:after {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          &:before {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #03aa72;
            z-index: 2;
          }
          &:after {
            width: 1px;
            height: 100%;
            background-color: #125e34;
          }
        }
        .slide-main-wrap {
          display: inline-block;
          padding-top: 4px;
          padding-bottom: 10px;
          width: calc(100% - 30px);
          margin-left: 30px;
          .slide-main {
            background-color: rgba(27, 165, 101, 0.2);
            padding: 10px;
            position: relative;
            cursor: pointer;
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: -10px;
              border-top: 10px solid rgba(27, 165, 101, 0.2);
              border-left: 10px solid transparent;
            }
            .panel-head {
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              font-size: 14px;
              line-height: 28px;
              color: #ffffff;
              .c-name {
                display: inline-block;
                line-height: 20px;
                flex: 1;
                font-weight: bold;
                padding-right: 15px;
              }
              .t-t {
                flex: 1;
                font-size: 14px;
                white-space: pre-wrap;
              }
            }
            .panel-des {
              font-size: 14px;
              color: #9dd1d7;
              line-height: 22px;
            }
          }
        }
        &.lastLine {
          margin-bottom: 40% !important;
          .line-wrap:after {
            height: 0 !important;
          }
        }
      }
    }
    .nodata {
      height: 100%;
      color: #00f6ff;
      font-size: 14px;
      text-align: center;
      line-height: 20vh;
    }
  }
}
</style>
